import { type StopEditingEvent } from '../events/types';
import { type SelectionState } from '../state/types';

import { type ReducerResponse } from './types';

export function stopEditingReducer(
  state: SelectionState,
  event: StopEditingEvent
): ReducerResponse {
  if (!state.isEditing) {
    return { next: state, delta: { kind: 'noop' } };
  }

  const position =
    state.activeEdit?.editingContext === 'panel'
      ? state.activeEdit.position
      : state.focusedCell ?? state.activeEdit?.position;
  const next = {
    ...state,
    isEditing: false,
    activeEdit: null,
  };

  if (!position) {
    return {
      next,
      delta: {
        kind: 'cellEditStopped',
        source: event.source,
      },
    };
  }

  return {
    next,
    delta: {
      kind: 'cellEditStopped',
      position,
      source: event.source,
    },
  };
}
